import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

import { Checkbox } from '../../../components/ui/Checkbox';

const SearchFilter = ({ 
  persons, 
  onFilterChange,
  onSearchChange 
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPersons, setSelectedPersons] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    onSearchChange(value);
  };

  const handlePersonToggle = (personId) => {
    const newSelected = selectedPersons?.includes(personId)
      ? selectedPersons?.filter(id => id !== personId)
      : [...selectedPersons, personId];
    
    setSelectedPersons(newSelected);
    onFilterChange(newSelected);
  };

  const handleClearFilters = () => {
    setSelectedPersons([]);
    setSearchQuery('');
    onFilterChange([]);
    onSearchChange('');
  };

  const activeFilterCount = selectedPersons?.length;

  return (
    <div className="bg-card rounded-xl border border-border shadow-warm-sm p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col md:flex-row gap-3 md:gap-4">
        <div className="flex-1">
          <div className="relative">
            <Icon 
              name="search" 
              size={20} 
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Search activities..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full pl-10 pr-4 py-2.5 md:py-3 rounded-lg border border-input bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        <div className="flex gap-2">
          <div className="relative">
            <Button
              variant="outline"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
              className="relative"
            >
              <Icon name="filter" size={20} />
              <span className="hidden md:inline ml-2">Filter</span>
              {activeFilterCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-primary text-primary-foreground text-xs font-bold rounded-full flex items-center justify-center">
                  {activeFilterCount}
                </span>
              )}
            </Button>

            {isFilterOpen && (
              <div className="absolute top-full right-0 mt-2 w-64 bg-popover border border-border rounded-lg shadow-warm-lg p-4 z-50">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-sm font-semibold text-foreground">
                    Filter by Family Member
                  </h3>
                  {activeFilterCount > 0 && (
                    <button
                      onClick={handleClearFilters}
                      className="text-xs text-primary hover:underline"
                    >
                      Clear all
                    </button>
                  )}
                </div>

                <div className="space-y-2">
                  {persons?.map((person) => (
                    <label
                      key={person?.id}
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-muted cursor-pointer transition-colors"
                    >
                      <Checkbox
                        checked={selectedPersons?.includes(person?.id)}
                        onChange={() => handlePersonToggle(person?.id)}
                      />
                      <div className="flex items-center gap-2 flex-1">
                        <div
                          className="w-4 h-4 rounded-full flex-shrink-0"
                          style={{ backgroundColor: person?.color }}
                        />
                        <span className="text-sm text-foreground">
                          {person?.name}
                        </span>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>

          {(searchQuery || activeFilterCount > 0) && (
            <Button
              variant="ghost"
              onClick={handleClearFilters}
              iconName="x"
              iconSize={16}
            >
              <span className="hidden md:inline">Clear</span>
            </Button>
          )}
        </div>
      </div>
      {activeFilterCount > 0 && (
        <div className="flex flex-wrap gap-2 mt-3 pt-3 border-t border-border">
          {selectedPersons?.map((personId) => {
            const person = persons?.find(p => p?.id === personId);
            return (
              <div
                key={personId}
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium"
                style={{ 
                  backgroundColor: `${person?.color}20`,
                  color: person?.color
                }}
              >
                <span>{person?.name}</span>
                <button
                  onClick={() => handlePersonToggle(personId)}
                  className="hover:opacity-70"
                  aria-label={`Remove ${person?.name} filter`}
                >
                  <Icon name="x" size={14} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SearchFilter;